(function () {
  function setLoading(button, isLoading) {
    var label = button.querySelector('.gb-download-button__label');
    button.disabled = isLoading;
    if (label) {
      label.textContent = isLoading ? 'Downloading…' : label.getAttribute('data-original-text') || label.textContent;
    }
  }

  function showError(button) {
    var card = button.closest('.gb-download-card');
    var errorEl = card && card.querySelector('.gb-download-error');
    if (errorEl) errorEl.hidden = false;
  }

  async function downloadPdf(button) {
    var url = button.getAttribute('data-url');
    var filename = button.getAttribute('data-filename') || 'download.pdf';
    var label = button.querySelector('.gb-download-button__label');

    if (!url) return;
    if (label && !label.getAttribute('data-original-text')) {
      label.setAttribute('data-original-text', label.textContent);
    }

    setLoading(button, true);

    try {
      var response = await fetch(url, { credentials: 'omit' });
      if (!response.ok) throw new Error('Request failed with status ' + response.status);

      var blob = await response.blob();
      var blobUrl = window.URL.createObjectURL(blob);

      var link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.setTimeout(function () {
        window.URL.revokeObjectURL(blobUrl);
      }, 1000);
    } catch (error) {
      console.error('Distributors PDF download failed:', error);
      showError(button);
    } finally {
      setLoading(button, false);
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pdf-download]');
    if (!button) return;
    event.preventDefault();
    downloadPdf(button);
  });
})();
